import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'beupdatesuccessmsg',
  templateUrl: './best-efforts-update-success-message-modal.component.html',
  styleUrls: ['./best-efforts-update-success-message-modal.component.sass']

})

export class BEUpdateSuccessMessageModalComponent implements OnInit {
  message: string;
  title: string;
  topBorderClass: string;


  constructor(private router :Router, public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.title = '';
    this.topBorderClass = `top-border-green`;
  }

  okClick(){
    this.activeModal.dismiss();
  }
}

